import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { BiTrash } from "react-icons/bi";

import logo from "../../../assets/images/logo.png";
import { removeBundleFromCart } from "../../../redux/cart";
import { isValidUrl } from "../../../helpers/isValidUrl";
import QuantityControls from "../../QuantityControls/QuantityControls";

const CartBundleItem = ({ bundle }) => {
  // location
  const location = useLocation();
  const { pathname } = location;

  // redux
  const dispatch = useDispatch();
  const { selectedCar } = useSelector((state) => state.car);

  // remove from card handle
  const bundleRemoveFromCartHandler = (bundleId) => {
    dispatch(removeBundleFromCart(bundleId));
  };

  const [expandedDetails, setExpandedDetails] = useState(false);

  function toggleDetailsView() {
    setExpandedDetails(!expandedDetails);
  }

  const bundleImages = bundle.skuList.map((sku) => sku.images).flat();

  const bundleIsMisMatch = bundle.skuList.some((sku) => sku.isMisMatch);

  return (
    <article
      className={classNames(
        "min-w-0 min-h-fit border border-light-gray rounded-lg py-4 flex flex-col item-center gap-4",
        { "border-red-400": bundleIsMisMatch && selectedCar.carDetails?.id }
      )}
    >
      {bundleIsMisMatch && selectedCar.carDetails?.id && (
        <p className="text-red-500 font-bold text-center">
          هذه المجموعة لا تتطابق مع السيارة المختارة
        </p>
      )}

      <div className="flex justify-between items-start pt-4 mx-10">
        <div className="flex flex-col justify-center items-center gap-4">
          <div className="flex items-center">
            {bundleImages
              .filter((_, index) => index < 3)
              .map((image, index) => (
                <div
                  key={index}
                  className={classNames(
                    `h-24 w-24 rounded-full overflow-hidden border border-gray-200`,
                    { "-mr-3": index !== 0 }
                  )}
                >
                  <img
                    src={isValidUrl(image.imageUrl) ? image.imageUrl : logo}
                    alt="bundleSkuImage"
                    className="h-full w-full object-cover"
                  />
                </div>
              ))}

            {bundleImages.length > 3 && (
              <div
                className={classNames(
                  `flex justify-center items-center h-24 w-24`,
                  `font-bold text-2xl`,
                  `rounded-full border border-gray-200 bg-gray-50`,
                  `-mr-3`
                )}
              >
                <span>{`+${bundleImages.length - 3}`}</span>
              </div>
            )}
          </div>

          <div className="flex items-center ">{bundle.name}</div>

          <div className="flex ">
            <span className="bundle-old-price ml-5">
              {bundle.priceBeforeDiscount} {"جم "}
            </span>{" "}
            <span className="text-#216DA6 font-extrabold">
              {bundle.priceBeforeDiscount - bundle.discount} {"جم "}
            </span>
          </div>
        </div>

        <QuantityControls product={bundle} isBundle />
      </div>

      <div>
        <div className="pr-2">
          <button
            className="bg-transparent hover:underline inline-flex items-center p-2"
            onClick={toggleDetailsView}
          >
            {expandedDetails ? (
              <>
                <span>إخفاء التفاصيل</span>
                <IoIosArrowUp />
              </>
            ) : (
              <>
                <span>عرض التفاصيل </span> <IoIosArrowDown />{" "}
              </>
            )}
          </button>
        </div>

        {expandedDetails && (
          <div className="bg-gray-100 p-2">
            <p className="text-base font-bold mb-3">هذه المجموعة تتكون من:</p>
            <ul className="list-disc ">
              {bundle?.skuList.map((sku) => (
                <Link
                  key={sku.id}
                  className="block text-sm font-normal hover:text-blue-400 mr-8 mb-2"
                  to={`/product/${sku.id}`}
                  state={{ from: pathname }}
                >
                  <li>{`(${sku.quantity})  ${sku.commercialName}`}</li>
                </Link>
              ))}
            </ul>
          </div>
        )}
      </div>

      <p className="w-fit text-sm font-semibold text-#677181 pr-4 mb-2">
        <button
          className="flex items-center gap-2 text-red-400"
          onClick={() => bundleRemoveFromCartHandler(bundle.id)}
        >
          <BiTrash />
          حذف
        </button>
      </p>
    </article>
  );
};
export default CartBundleItem;
